// extracted by mini-css-extract-plugin
export default {"root":"PageLoader_root__+LNYw"};